import { useCallback } from "react";
import { useAuth } from "../contexts/AuthProvider";

/** Looks up a department's display name among the departments the signed-in user belongs to. */
export const useGetDepartmentDisplayName = (): ((departmentId: string) => string) => {
	const { userInfo } = useAuth();
	return useCallback(
		// DEFAULT: a department the user doesn't belong to (or no longer does) shows no label.
		(departmentId: string): string => userInfo.departments.find((dept) => dept.department_id === departmentId)?.display_name || "",
		[userInfo.departments],
	);
};
